// extracted by mini-css-extract-plugin
export default {"progressbar":"BarraLoader_progressbar__473Ao","progressInfinite":"BarraLoader_progressInfinite__b3ozI","colorAnimation":"BarraLoader_colorAnimation__y9uFv"};